/**
 * The total a paginated listing reports in its `Vizit-Total-Count` header, or `fallback` when the header is missing
 * or unreadable, so a total never reads as `NaN`. Seams that know their page pass its length as the fallback.
 */
export function extractTotalCount(response: Response, fallback = 0): number {
  const total = Number.parseInt(response.headers.get('vizit-total-count') ?? '', 10);
  return Number.isFinite(total) ? total : fallback;
}
